import { render, staticRenderFns } from "./AcceptedCard.vue?vue&type=template&id=db3cab24&"
import script from "./AcceptedCard.vue?vue&type=script&lang=js&"
export * from "./AcceptedCard.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VAvatar,VCard,VDivider,VImg})
